// extracted by mini-css-extract-plugin
module.exports = {"root":"MantineSegmentedControl_root__XlAS0"};